
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ENTranslate from './util/local/en/translation.json';
import ESTranslate from './util/local/es/translation.json';

  
  // Initialize i18n
  i18n.use(initReactI18next).init({
    resources: {
      en: {
        translation: ENTranslate,
      },
      es: {
        translation: ESTranslate,
      },
    },
    lng: 'es', // Default language
    fallbackLng: 'es', // Fallback language if the selected language is unavailable
    interpolation: {
      escapeValue: false, // React already escapes values to prevent XSS
    },
  });
  
  export default i18n;